export function effectiveQueryParams() {
    if (window.location.search) {
        return new URLSearchParams(window.location.search);
    }
    else if (window.location.hash && window.location.hash.includes("?")) {
        return new URLSearchParams(window.location.hash.split("?")[1]);
    }
    else {
        return new URLSearchParams();
    }
}
